"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.ContentWrapper = styled_components_1.default.div `
  position: absolute;
  ${(props) => (props.$openSide === "right" ? "left: 0;" : "right: 0;")}
  top: 30px;
  z-index: 1;
  ${(props) => props.hidden && `display:none;`}
`;
//# sourceMappingURL=ActionButtonDropdown.styles.js.map